// extracted by mini-css-extract-plugin
module.exports = {"label":"FieldLabel_label__zuSjO"};